/* Meta LP — interactive layer only. Product routing happens server-side
   via the page handle (m-high-shine, m-matte-clay, etc.). This file:
     1. Adds-to-cart on Shop Now / Bundle clicks
     2. Wraps the post-add redirect through /discount/META25 (single) or
        /discount/META30 (bundle) so the code auto-applies at /cart
     3. Optional ad-creative headline/body/hero override via ?aid=
     4. GA4 events (meta_lp_view, meta_lp_cta_click, meta_lp_bundle_click,
        meta_lp_scroll_50, meta_lp_scroll_90)
     5. Sticky CTA on scroll
   Graceful fallback: if anything fails, the static defaults stay visible. */

(function () {
  'use strict';

  var SINGLE_DISCOUNT = 'META25';
  var BUNDLE_DISCOUNT = 'META30';

  function param(name) {
    var m = new RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
    return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : '';
  }

  // GA4 / dataLayer event helper. Fires to both gtag (if present) and the
  // dataLayer queue (covers GTM-wired stores). transport=beacon so events
  // ship before navigation away from the page.
  function track(name, params) {
    var payload = Object.assign({}, params || {});
    payload.aid = payload.aid || param('aid') || '';
    payload.product_key = payload.product_key || param('p') || readProductKey() || '';
    payload.variant = payload.variant || param('v') || 'lp';
    try {
      if (typeof window.gtag === 'function') {
        var gtagParams = Object.assign({ transport_type: 'beacon' }, payload);
        window.gtag('event', name, gtagParams);
      }
    } catch (e) { /* no-op */ }
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, payload));
    } catch (e) { /* no-op */ }
  }

  function readProductKey() {
    var root = document.querySelector('[data-meta-lp]');
    return root ? (root.getAttribute('data-product-key') || '') : '';
  }

  // Polyfill Object.assign for the small chance of an older mobile browser.
  if (typeof Object.assign !== 'function') {
    Object.assign = function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var src = arguments[i];
        if (src) for (var k in src) if (Object.prototype.hasOwnProperty.call(src, k)) target[k] = src[k];
      }
      return target;
    };
  }

  function wireScrollDepth() {
    var fired = {};
    function check() {
      var doc = document.documentElement;
      var body = document.body;
      var scrolled = window.scrollY || doc.scrollTop || 0;
      var viewport = window.innerHeight || doc.clientHeight || 0;
      var total = Math.max(doc.scrollHeight, body ? body.scrollHeight : 0) - viewport;
      if (total <= 0) return;
      var pct = scrolled / total;
      if (pct >= 0.5 && !fired.s50) { fired.s50 = 1; track('meta_lp_scroll_50', {}); }
      if (pct >= 0.9 && !fired.s90) {
        fired.s90 = 1;
        track('meta_lp_scroll_90', {});
        window.removeEventListener('scroll', check);
      }
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  }

  // Optional ad-creative override: when ?aid= matches an entry in
  // ad_creatives.json, swap the headline / sub / hero. The product itself
  // is already correct server-side — this is only for ad-level copy
  // continuity (so the LP headline matches the ad headline the user clicked).
  function applyHook(creative) {
    if (!creative) return;
    var headline = creative.headline || '';
    var body = creative.body || '';
    var hero = creative.hero_image_url || '';

    if (headline) {
      var h1 = document.querySelector('[data-meta-lp-headline]');
      if (h1) h1.textContent = headline;
    }
    if (body) {
      var sub = document.querySelector('[data-meta-lp-sub]');
      if (sub) sub.textContent = body;
    }
    if (hero) {
      var img = document.querySelector('[data-meta-lp-hero]');
      if (img) {
        img.src = hero;
        img.alt = headline || img.alt;
      }
    }
  }

  function wireAddBundle() {
    document.querySelectorAll('[data-meta-lp-add-bundle]').forEach(function (btn) {
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        var handlesAttr = btn.getAttribute('data-handles') || '';
        var handles = handlesAttr.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
        track('meta_lp_bundle_click', { handles: handles.join(','), count: handles.length });
        if (!handles.length) return;
        addRoutineToCart(btn, handles);
      });
    });
  }

  function wireShopNowCta() {
    var ctas = document.querySelectorAll('[data-meta-lp-cta], [data-meta-lp-cta-inline], [data-meta-lp-cta-sticky]');
    ctas.forEach(function (cta) {
      cta.addEventListener('click', function (ev) {
        var match = (cta.getAttribute('href') || '').match(/\/products\/([^?#]+)/);
        var handle = match ? match[1] : (cta.getAttribute('data-meta-lp-cta-default-handle') || '');
        var placement = cta.hasAttribute('data-meta-lp-cta-sticky') ? 'sticky'
                      : cta.hasAttribute('data-meta-lp-cta-inline') ? 'inline'
                      : 'hero';
        track('meta_lp_cta_click', { handle: handle, placement: placement });
        if (!handle) return; // fall back to native href navigation
        ev.preventDefault();
        addSingleToCart(cta, handle);
      });
    });
  }

  function addSingleToCart(btn, handle) {
    var orig = btn.textContent;
    btn.textContent = 'Adding…';
    btn.classList.add('is-loading');
    variantIdForHandle(handle)
      .then(function (vid) {
        if (!vid) throw new Error('no variant');
        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          // omitting selling_plan -> one-time purchase, even on subscription-enabled products
          body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
        });
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        window.location.href = '/discount/' + SINGLE_DISCOUNT + '?redirect=/checkout';
      })
      .catch(function (e) {
        console.error('shop now add failed', e);
        btn.textContent = orig;
        btn.classList.remove('is-loading');
      });
  }

  function variantIdForHandle(handle) {
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var v = (p.variants || [])[0];
        return v ? v.id : null;
      });
  }

  function addRoutineToCart(btn, handles) {
    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Adding…';

    Promise.all(handles.map(variantIdForHandle))
      .then(function (ids) {
        var items = ids.filter(Boolean).map(function (id) { return { id: id, quantity: 1 }; });
        if (!items.length) throw new Error('no variants resolved');
        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        // route via /discount/META30 so the bundle code auto-applies, then land on /checkout
        window.location.href = '/discount/' + BUNDLE_DISCOUNT + '?redirect=/checkout';
      })
      .catch(function (e) {
        console.error('add bundle failed', e);
        btn.disabled = false;
        btn.textContent = originalText;
      });
  }

  // Sticky CTA: show after the user scrolls past the hero
  function wireStickyCta() {
    var sticky = document.querySelector('[data-meta-lp-sticky]');
    var hook = document.querySelector('[data-meta-lp-hook]');
    if (!sticky || !hook) return;
    var threshold = hook.offsetTop + hook.offsetHeight - 100;
    function onScroll() {
      var show = window.scrollY > threshold;
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      sticky.classList.toggle('is-visible', show);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function init() {
    var root = document.querySelector('[data-meta-lp]');
    if (!root) return;

    track('meta_lp_view', {});

    wireAddBundle();
    wireShopNowCta();
    wireStickyCta();
    wireScrollDepth();

    var aid = param('aid');
    if (!aid) return;

    // Ad-creative copy override: fetch ad_creatives.json and, if this ad ID
    // has a matching entry, swap the headline/sub/hero to the ad's copy so
    // the LP message matches what the user clicked.
    var url = root.getAttribute('data-creatives-url') || '/cdn/ad_creatives.json';
    fetch(url, { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function (data) {
        var c = (data && data.creatives && data.creatives[aid]) || null;
        if (!c) return;
        applyHook(c);
      })
      .catch(function (e) { console.warn('meta-lp: creative lookup failed', e); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
